import { Button } from "@/components/ui/Button";
import { DevProfileSwitcher } from "@/components/inquiry/DevProfileSwitcher";
import { InquiryFlow } from "@/components/inquiry/InquiryFlow";
import { InquiryShell } from "@/components/inquiry/InquiryShell";
import { useInquiryProfile } from "@/components/inquiry/useInquiryProfile";
import { useSeo } from "@/lib/use-seo";
import styles from "./inquiry.module.css";

const PAGE_DESCRIPTION =
  "Submit a rental equipment enquiry with event details, logistics, and any supporting documents.";


export default function InquiryPage(): React.JSX.Element {
  const profileState = useInquiryProfile();
  const company =
    profileState.status === "success" ? profileState.profile.company : undefined;

  useSeo({
	title: company?.name
		? `Get a Quote | ${company.name}`
		: "Get a Quote",
    description: PAGE_DESCRIPTION,
	canonical: `${window.location.origin}/enquiry`,
	siteName: company?.name,
	jsonLd: company?.name
		? [{
			"@context": "https://schema.org",
			"@type": "Organization",
			name: company.name,
			url: company.publicUrl || window.location.origin,
			email: company.contactEmail || undefined,
		}]
		: undefined,
  });

  if (profileState.status === "loading") {
    return (
      <InquiryShell>
        <p className={styles.loading}>Loading enquiry form…</p>
        <DevProfileSwitcher />
      </InquiryShell>
    );
  }
  if (profileState.status === "error") {
    return (
      <InquiryShell>
        <h1 className={styles.errorHeading}>We couldn&apos;t load this form</h1>
        <p className={styles.errorMessage}>{profileState.message}</p>
        <Button onClick={profileState.retry}>Try again</Button>
        <DevProfileSwitcher />
      </InquiryShell>
    );
  }

  return (
    <>
      <InquiryFlow profile={profileState.profile} />
      <DevProfileSwitcher />
    </>
  );
}
